// src/practices/ExploreUIElements.js
import React, { useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import {
  Container,
  Row,
  Col,
  
  Button,
  FormGroup,
  FormControl,
  FormLabel,
  FormCheck,
  
  Table,
  OverlayTrigger,
  Tooltip,
  
  ProgressBar,
  Modal,
  Nav,
  TabContent,
  TabPane,
  Accordion,
  ListGroup,
  Toast,
} from 'react-bootstrap';

import TesterBudNavbar from '../../subComponent/TesterBudNavBar';
import HeroImage from '../icons/form-icon.png';

const ExploreAutomateUIElements = () => {
  const [textFieldValue, setTextFieldValue] = useState('');
  const [textAreaValue, setTextAreaValue] = useState('');
  const [buttonClickCount, setButtonClickCount] = useState(0);
  const [singleCheckboxChecked, setSingleCheckboxChecked] = useState(false);
  const [multipleCheckboxes, setMultipleCheckboxes] = useState({
    option1: false,
    option2: false,
    option3: false,
  });
  const [selectedRadio, setSelectedRadio] = useState('');
  const [selectedSingleDropdown, setSelectedSingleDropdown] = useState('');
  const [selectedMultiDropdown, setSelectedMultiDropdown] = useState([]);
  const [linkClicked, setLinkClicked] = useState(false);
  const [imageClicked, setImageClicked] = useState(false);
  const [tableSortColumn, setTableSortColumn] = useState(null);
  
  const [sliderValue, setSliderValue] = useState(50);
  const [progressBarValue, setProgressBarValue] = useState(30);
  const [modalVisible, setModalVisible] = useState(false);
  const [datePickerValue, setDatePickerValue] = useState(''); // Basic text input for now
  const [fileSelected, setFileSelected] = useState(null);
  const [draggedItem, setDraggedItem] = useState(null);
  const [droppedInTarget, setDroppedInTarget] = useState(false);
  const [iframeMessage, setIframeMessage] = useState('');
  const [dynamicContent, setDynamicContent] = useState('Initial Content');

  const [notificationVisible, setNotificationVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('tab1');
  const [accordionOpen, setAccordionOpen] = useState(null);
  const [virtualScrollIndex, setVirtualScrollIndex] = useState(0);

  const countries = ['USA', 'Canada', 'UK', 'India', 'Australia'];
  const multiSelectOptions = ['Option A', 'Option B', 'Option C', 'Option D'];
  const radioOptions = ['Radio 1', 'Radio 2', 'Radio 3'];

  const [tableSortDirection, setTableSortDirection] = useState('asc');

  const sortedTableData = useMemo(() => {
    const tableData = [
      { id: 1, name: 'Zui', age: 30 },
      { id: 3, name: 'Bob', age: 25 },
      { id: 2, name: 'Charlie', age: 35 },
      { id: 5, name: 'Ashley', age: 30 },
      { id: 4, name: 'Nat', age: 25 },
      { id: 6, name: 'Jim', age: 35 },
    ];

    if (!tableSortColumn) {
      return tableData;
    }

    const sortedData = [...tableData].sort((a, b) => {
      const valueA = a[tableSortColumn];
      const valueB = b[tableSortColumn];

      if (typeof valueA === 'string' && typeof valueB === 'string') {
        return tableSortDirection === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
      } else {
        return tableSortDirection === 'asc' ? valueA - valueB : valueB - valueA;
      }
    });

    return sortedData;
  }, [tableSortColumn, tableSortDirection]);

  const handleButtonClick = () => {
    setButtonClickCount(buttonClickCount + 1);
  };

  const handleSingleCheckboxChange = (e) => {
    setSingleCheckboxChecked(e.target.checked);
  };

  const handleMultipleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setMultipleCheckboxes({ ...multipleCheckboxes, [name]: checked });
  };

  const handleRadioChange = (e) => {
    setSelectedRadio(e.target.value);
  };

  const handleSingleDropdownChange = (e) => {
    setSelectedSingleDropdown(e.target.value);
  };

  const handleMultiDropdownChange = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions).map((option) => option.value);
    setSelectedMultiDropdown(selectedOptions);
  };

  const handleLinkClick = (e) => {
    e.preventDefault();
    setLinkClicked(true);
    setTimeout(() => setLinkClicked(false), 2000); // Reset after a short delay
  };

  const handleImageClick = () => {
    setImageClicked(true);
    setTimeout(() => setImageClicked(false), 2000); // Reset after a short delay
  };

  const handleTableSort = (column) => {
    if (column === tableSortColumn) {
      // If clicking the same column, toggle the direction
      setTableSortDirection(tableSortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      // If clicking a new column, set it as the sort column and default to ascending
      setTableSortColumn(column);
      setTableSortDirection('asc');
    }
  };

  const handleSliderChange = (e) => {
    setSliderValue(parseInt(e.target.value));
  };

  const handleProgressBarIncrement = () => {
    setProgressBarValue((prev) => Math.min(100, prev + 10));
  };

  const handleModalToggle = () => {
    setModalVisible(!modalVisible);
  };

  const handleFileSelect = (e) => {
    setFileSelected(e.target.files[0]?.name || null);
  };

  const handleDragStart = (e, itemName) => {
    setDraggedItem(itemName);
    setDroppedInTarget(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    if (draggedItem) {
      setDroppedInTarget(true);
      setDraggedItem(null);
    }
  };

  const handleIframeLoad = () => {
    // In a real scenario, you might interact with the iframe content
    setIframeMessage('Iframe loaded');
  };

  const updateDynamicContent = () => {
    setDynamicContent(`Updated at ${new Date().toLocaleTimeString()}`);
  };

  const showNotification = () => {
    setNotificationVisible(true);
    setTimeout(() => setNotificationVisible(false), 3000);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handleAccordionToggle = (item) => {
    setAccordionOpen(accordionOpen === item ? null : item);
  };

  const handleVirtualScroll = (e) => {
    setVirtualScrollIndex(e.target.scrollTop);
    // In a real scenario with a large dataset, you would load data dynamically
  };

  const virtualScrollItems = Array.from({ length: 50 }, (_, i) => `Item ${i + 1}`);

  return (
    <HelmetProvider>
      <Helmet>
        <title>Practice Automating Web Elements with Selenium | TesterBud</title>
        <meta http-equiv="Content-type" content="text/html;charset=UTF-8"></meta>
        <meta
          name="description"
          content="Practice identifying and automating various UI elements on TesterBud's dummy page. Learn Selenium locators and techniques for effective web automation."
        />
        <meta
          name="keywords"
          content="automate ui elements, ui element automation practice, selenium ui automation, automate web elements, practice web element automation, learn ui automation elements, explore ui elements automation, selenium locators practice, xpath practice elements, css selector practice elements, automate buttons selenium, automate text fields selenium, automate dropdowns selenium, identify web elements selenium, TesterBud ui automation practice, free ui automation practice"
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="TesterBud Team" />
        <meta property="og:title" content="Practice Automating Web Elements with Selenium | TesterBud" />
        <meta
          property="og:description"
          content="Practice identifying and automating various UI elements on TesterBud's dummy page. Learn Selenium locators and techniques for effective web automation."
        />
        <meta
          name="keywords"
          content="automate ui elements, ui element automation practice, selenium ui automation, automate web elements, practice web element automation, learn ui automation elements, explore ui elements automation, selenium locators practice, xpath practice elements, css selector practice elements, automate buttons selenium, automate text fields selenium, automate dropdowns selenium, identify web elements selenium, TesterBud ui automation practice, free ui automation practice"
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://testerbud.com/practice-different-ui-elements" />
        <meta name="geo.region" content="GLOBAL" />
        <meta name="geo.placename" content="Global" />
      </Helmet>
      <Container fluid className="hero-section bg-primary text-white py-1" style={{ position: 'relative', overflow: 'hidden' }}>
        <Row className="align-items-center justify-content-center">

          <Col md={6} className="text-center text-md-start">
            <h1 className="display-4 fw-bold mb-3">TesterBud: Dummy Login Page to Practice and Automate</h1>

            <p className="lead mb-4">
              Explore our dummy login websites and hone your skills in automating login forms and submission processes. Ideal for Selenium, Cypress, and more.
            </p><p className="lead mb-4">
              Practise, Create Test case, Automate it and become more confident Frontend automation expert. 🚀
            </p>


          </Col>
          <Col md={5} className="d-none d-md-block text-center">
            {/* Replace with your actual hero image component or import */}
            <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-start' }}>
              <div
                style={{
                  width: '50%', // Adjust the size of the circular area
                  height: '50%', // Ensure width and height are equal for a perfect circle
                  borderRadius: '0%', // This creates the circular shape
                  overflow: 'auto', // Clips the image to the circle
                  marginTop: '-4%',
                  marginRight: '10%',
                  marginBottom: '-4%',
                }}
              >
                <img src={HeroImage} alt="Automation Illustration" className="img-fluid" style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain', // Or 'cover' depending on desired behavior
                }} />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
<TesterBudNavbar/>
      <Container className="mt-5 explore-ui-container">
        <div className="content-wrapper">
          <h2 className="text-center mb-4 section-title">Explore and Automate UI Elements</h2>
          <p className="mb-4 text-left lead">
            <b>
              <i>Explore and Automate UI Elements</i> is your hands-on playground to understand and practice UI
              automation. Interact with different UI components, observe their behaviors, and see real-time outputs
              to enhance your automation skills. This page helps you learn how to automate elements like buttons,
              checkboxes, dropdowns, tables, and more—making it easier to build robust automation scripts for testing!
              🚀
            </b>
          </p>

          <h3 className="section-title">Basic Elements</h3>
          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6} >
              <FormGroup >
                <FormLabel htmlFor="textField">Text Field (Input Box):</FormLabel>
                <FormControl
                  type="text"
                  id="textField"
                  value={textFieldValue}
                  onChange={(e) => setTextFieldValue(e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">{textFieldValue}</div>
            </Col>
          </Row>

          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel htmlFor="textArea">Text Area:</FormLabel>
                <FormControl
                  as="textarea"
                  id="textArea"
                  rows={3}
                  value={textAreaValue}
                  onChange={(e) => setTextAreaValue(e.target.value)}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">{textAreaValue}</div>
            </Col>
          </Row>

          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel>Button:</FormLabel>
                <Button variant="primary" onClick={handleButtonClick}>
                  Click Me
                </Button>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">Clicked {buttonClickCount} times</div>
            </Col>
          </Row>

          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel>Checkbox (Single):</FormLabel>
                <FormCheck>
                  <FormCheck.Input
                    type="checkbox"
                    checked={singleCheckboxChecked}
                    onChange={handleSingleCheckboxChange}
                  />
                  <FormCheck.Label>Single Option</FormCheck.Label>
                </FormCheck>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">{singleCheckboxChecked ? 'Checked' : 'Unchecked'}</div>
            </Col>
          </Row>

          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel>Checkboxes (Multiple):</FormLabel>
                <div>
                  <FormCheck>
                    <FormCheck.Input
                      type="checkbox"
                      name="option1"
                      checked={multipleCheckboxes.option1}
                      onChange={handleMultipleCheckboxChange}
                    />
                    <FormCheck.Label>Option 1</FormCheck.Label>
                  </FormCheck>
                  <FormCheck>
                    <FormCheck.Input
                      type="checkbox"
                      name="option2"
                      checked={multipleCheckboxes.option2}
                      onChange={handleMultipleCheckboxChange}
                    />
                    <FormCheck.Label>Option 2</FormCheck.Label>
                  </FormCheck>
                  <FormCheck>
                    <FormCheck.Input
                      type="checkbox"
                      name="option3"
                      checked={multipleCheckboxes.option3}
                      onChange={handleMultipleCheckboxChange}
                    />
                    <FormCheck.Label>Option 3</FormCheck.Label>
                  </FormCheck>
                </div>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">
                Checked: {Object.keys(multipleCheckboxes)
                  .filter((key) => multipleCheckboxes[key])
                  .join(', ')}
              </div>
            </Col>
          </Row>

          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel>Radio Buttons:</FormLabel>
                <div>
                  {radioOptions.map((option) => (
                    <FormCheck key={option} type="radio">
                      <FormCheck.Input
                        type="radio"
                        name="radioGroup"
                        value={option}
                        checked={selectedRadio === option}
                        onChange={handleRadioChange}
                      />
                      <FormCheck.Label>{option}</FormCheck.Label>
                    </FormCheck>
                  ))}
                </div>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">{selectedRadio || 'No option selected'}</div>
            </Col>
          </Row>

          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel htmlFor="singleDropdown">Dropdown (Single Select):</FormLabel>
                <FormControl
                  as="select"
                  id="singleDropdown"
                  value={selectedSingleDropdown}
                  onChange={handleSingleDropdownChange}
                >
                  <option value="">Select a country</option>
                  {countries.map((country) => (
                    <option key={country} value={country}>
                      {country}
                    </option>
                  ))}
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">{selectedSingleDropdown || 'No option selected'}</div>
            </Col>
          </Row>

          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel htmlFor="multiDropdown">Dropdown (Multi-Select):</FormLabel>
                <FormControl
                  as="select"
                  id="multiDropdown"
                  multiple
                  value={selectedMultiDropdown}
                  onChange={handleMultiDropdownChange}
                >
                  {multiSelectOptions.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </FormControl>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">
                {selectedMultiDropdown.length > 0 ? selectedMultiDropdown.join(', ') : 'No options selected'}
              </div>
            </Col>
          </Row>

          <h3 className="section-title">Interactive Elements</h3>
          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
              <FormLabel>Link (Anchor Tag):</FormLabel>
                <Link to="#" onClick={handleLinkClick}>
                  Click Me
                </Link>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">{linkClicked ? 'Link Clicked!' : 'Click the link'}</div>
            </Col>
          </Row>

          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel>Image:</FormLabel>
                <img
                  src={require('../../logo192.png')}
                  alt="Placeholder"
                  className="img-thumbnail"
                  style={{ maxWidth: '100px', cursor: 'pointer' }}
                  onClick={handleImageClick}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">{imageClicked ? 'Image Clicked!' : 'Click the image'}</div>
            </Col>
          </Row>

          <Row className="mb-3" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel>Table & Grid:</FormLabel>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th onClick={() => handleTableSort('id')} style={{ cursor: 'pointer', userSelect: 'none' }}>
                        ID
                      </th>
                      <th onClick={() => handleTableSort('name')} style={{ cursor: 'pointer', userSelect: 'none' }}>
                        Name
                      </th>
                      <th onClick={() => handleTableSort('age')} style={{ cursor: 'pointer', userSelect: 'none' }}>
                        Age
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedTableData.map((row) => (
                      <tr key={row.id}>
                        <td>{row.id}</td>
                        <td>{row.name}</td>
                        <td>{row.age}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                {tableSortColumn && (
                  <p className="mt-2 text-muted small">Sorted by: {tableSortColumn}</p>
                )}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">
                {tableSortColumn ? `Table sorted by ${tableSortColumn}` : 'Click a table header to "sort"'}
              </div>
            </Col>
          </Row>

          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel>Tooltip:</FormLabel>
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip id="tooltip-top">This is a tooltip!</Tooltip>}
                >
                  <span style={{ cursor: 'pointer' }}>Hover Me</span>
                </OverlayTrigger>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">{'Hover over "Hover Me"'}</div>
            </Col>
          </Row>

          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel>Slider:</FormLabel>
                <FormControl
                  type="range"
                  min="0"
                  max="100"
                  value={sliderValue}
                  onChange={handleSliderChange}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">Slider Value: {sliderValue}</div>
            </Col>
          </Row>

          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel>Progress Bar:</FormLabel>
                <ProgressBar now={progressBarValue} label={`${progressBarValue}%`} />
                <Button variant="success" className="mt-2" onClick={handleProgressBarIncrement}>
                  Increment Progress
                </Button>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">Progress: {progressBarValue}%</div>
            </Col>
          </Row>

          <h3 className="section-title">Complex UI Components</h3>
          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel>Modal & Popup:</FormLabel>
                <Button variant="info" onClick={handleModalToggle}>
                  Show Modal
                </Button>
                <Modal show={modalVisible} onHide={handleModalToggle}>
                  <Modal.Header closeButton>
                    <Modal.Title>This is a Modal</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>React Bootstrap Modal Example.</Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleModalToggle}>
                      Close
                    </Button>
                    <Button variant="primary" onClick={handleModalToggle}>
                      Save Changes
                    </Button>
                  </Modal.Footer>
                </Modal>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">{modalVisible ? 'Modal is open' : 'Click "Show Modal"'}</div>
            </Col>
          </Row>

          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel>Date Picker & Calendar:</FormLabel>
                {/* For a real date picker, you would integrate a library like react-datepicker */}
                <FormControl
                  type="text"
                  placeholder="YYYY-MM-DD (Simulated)"
                  value={datePickerValue}
                  onChange={(e) => setDatePickerValue(e.target.value)}
                />
                <p className="mt-2 text-muted small">
                  (This is a basic input for demonstration. Integrate a datepicker library for full functionality)
                </p>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">{datePickerValue || 'No date selected (simulated)'}</div>
            </Col>
          </Row>

          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel>File Upload & Download:</FormLabel>
                <FormControl type="file" onChange={handleFileSelect} />
                {fileSelected && <p className="mt-2 text-muted small">Selected file: {fileSelected}</p>}
                <Button variant="outline-secondary" className="mt-2" onClick={() => alert('Simulating Download')}>
                  Simulate Download
                </Button>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">
                {fileSelected ? `File "${fileSelected}" selected` : 'No file selected'}
                <br />
                (Download simulated via alert)
              </div>
            </Col>
          </Row>

          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel>Drag and Drop Elements:</FormLabel>
                <div
                  className="border p-2 text-center draggable"
                  draggable
                  onDragStart={(e) => handleDragStart(e, 'Draggable Item')}
                >
                  Drag Me
                </div>
                <div
                  className="border p-2 mt-2 text-center droppable"
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                >
                  Drop Here
                </div>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">
                {draggedItem ? `Dragging: ${draggedItem}` : droppedInTarget ? 'Dropped!' : 'Drag "Drag Me" to "Drop Here"'}
              </div>
            </Col>
          </Row>

          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel>Iframe:</FormLabel>
                <iframe
                  title="iframe-practice"
                  src="https://example.com"
                  width="100%"
                  height="150px"
                  style={{ border: '1px solid #ccc' }}
                  onLoad={handleIframeLoad}
                ></iframe>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">{iframeMessage || 'Iframe loading...'}</div>
            </Col>
          </Row>

          <h3 className="section-title">Advanced UI Elements</h3>
          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel>Dynamic Content (Simulated):</FormLabel>
                <div className="output-box">{dynamicContent}</div>
                <Button variant="warning" className="mt-2" onClick={updateDynamicContent}>
                  Update Content
                </Button>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">Click "Update Content" to see changes</div>
            </Col>
          </Row>

          <Row className="mb-3 align-items-center" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel>Notifications & Toast Messages:</FormLabel>
                <Button variant="success" onClick={showNotification}>
                  Show Notification
                </Button>
                <Toast
                  show={notificationVisible}
                  onClose={() => setNotificationVisible(false)}
                  style={{ position: 'absolute', top: 20, right: 20, zIndex: 1 }}
                >
                  <Toast.Header>
                    <strong className="me-auto">Success</strong>
                    <small>Just now</small>
                  </Toast.Header>
                  <Toast.Body>Operation completed successfully.</Toast.Body>
                </Toast>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">{notificationVisible ? 'Notification shown' : 'Click "Show Notification"'}</div>
            </Col>
          </Row>

          <Row className="mb-3" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel>Tabs:</FormLabel>
                <Nav variant="tabs" defaultActiveKey="tab1" onSelect={handleTabChange}>
                  <Nav.Item>
                    <Nav.Link eventKey="tab1">Tab 1</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="tab2">Tab 2</Nav.Link>
                  </Nav.Item>
                </Nav>
                <TabContent className="mt-2">
                  <TabPane eventKey="tab1">
                    <p>Content of Tab 1</p>
                  </TabPane>
                  <TabPane eventKey="tab2">
                    <p>Content of Tab 2</p>
                  </TabPane>
                </TabContent>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">Active Tab: {activeTab}</div>
            </Col>
          </Row>

          <Row className="mb-3" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel>Accordion:</FormLabel>
                <Accordion activeKey={accordionOpen} onSelect={handleAccordionToggle}>
                  <Accordion.Item eventKey="item1">
                    <Accordion.Header>Accordion Item #1</Accordion.Header>
                    <Accordion.Body>Content of Accordion Item #1</Accordion.Body>
                  </Accordion.Item>
                  <Accordion.Item eventKey="item2">
                    <Accordion.Header>Accordion Item #2</Accordion.Header>
                    <Accordion.Body>Content of Accordion Item #2</Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">
                {accordionOpen ? `Accordion item "${accordionOpen}" is open` : 'Open an accordion item'}
              </div>
            </Col>
          </Row>

          <Row className="mb-3" style={{ border: '1px solid #dee2e6', marginBottom: '1rem', padding: '15px', borderRadius: '0.25rem' }}>
            <Col md={6}>
              <FormGroup>
                <FormLabel>Virtual Scrolling (Simulated):</FormLabel>
                <div
                  className="border rounded p-2 overflow-auto"
                  style={{ height: '150px' }}
                  onScroll={handleVirtualScroll}
                >
                  <ListGroup>
                    {virtualScrollItems.map((item, index) => (
                      <ListGroup.Item key={index}>{item}</ListGroup.Item>
                    ))}
                  </ListGroup>
                </div>
                <p className="mt-2 text-muted small">Scroll to simulate virtual scrolling</p>
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormLabel>Output:</FormLabel>
              <div className="output-box">Scroll Position: {virtualScrollIndex}</div>
            </Col>
          </Row>
        </div>
      </Container>
      <footer className="bg-dark text-light text-center py-4 mt-auto">
                     <Container>
                       <p className="mb-1">Ready to start automating? Explore, practice, and master!</p>
                       <small>© 2025 TesterBud | Built for learners by learners 🚀</small>
                     </Container>
                   </footer>
    </HelmetProvider>
  );
};

export default ExploreAutomateUIElements;